import { FileWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-file-widget',
  templateUrl: './file.widget.html'
})
export class MyFileWidgetComponent extends FileWidget {

  onFileChange($event) {
    // const file = $event.target.files[0];
    // this.filedata.filename = file.name;
    // this.filedata.size = file.size;
    // this.filedata['content-type'] = file.type;
    // this.filedata.encoding = 'base64';
    // this.reader.readAsBinaryString(file);

    console.log('onFileChange:', $event)
  }

  upload(data) {
    console.log('select:', data)
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/file/file.widget.ts